__turbopack_context__.v({
  "main": "Layout-module__bPt_eG__main",
  "root": "Layout-module__bPt_eG__root",
  "sidebar": "Layout-module__bPt_eG__sidebar",
});
